export default __webpack_public_path__ + "static/media/load.af3cf2c8.svg";